import { MentorProfileChecklist as ChecklistPayload } from './MentorPortalService';

const ITEM_LABELS: Record<string, string> = {
    profile_fields: 'Profile setup',
    tracks_selected: 'Tracks selected',
    bio_filled: 'Bio filled',
    availability_set: 'Availability set',
    intro_message: 'Intro message sent',
};

type Props = {
    checklist: ChecklistPayload;
};

const MentorProfileChecklist = ({ checklist }: Props) => {
    const total = checklist.total || 5;
    const doneCount = checklist.doneCount ?? 0;
    const percent = total > 0 ? Math.round((doneCount / total) * 100) : 0;
    const label = checklist.progressLabel || `${doneCount} of ${total} complete`;

    return (
        <>
          
            <div className="col-lg-12 col-md-12">
                <div className="card border-0 shadow-sm rounded-3 p-4 mb-3 bg-white h-100" aria-label="Onboarding checklist">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6 className="fw-bold text-dark mb-0">Onboarding Checklist</h6>
                        <span className="badge bg-success bg-opacity-10 text-success fw-bold py-1 px-2 font-11 rounded-pill">{label}</span>
                    </div>

                    
                    <div className="progress mb-3" style={{height:'8px'}}>
                        <div className="progress-bar bg-success" role="progressbar" style={{ width: `${percent}%` }} aria-valuenow={doneCount} aria-valuemin={0} aria-valuemax={total}></div>
                    </div>
                    <div className="list-group list-group-flush">
                        {(checklist.items || []).map((item) => {
                            const done = item.done === true;
                            const labelText = ITEM_LABELS[item.id] || item.id;
                            return (
                                <div
                                    key={item.id}
                                    className={`list-group-item d-flex align-items-center gap-3 py-2 px-0 border-light-subtle bg-transparent ${
                                        item.done ? 'is-done' : 'is-pending'
                                    }`}
                                    >
                                
                                    
                                    <span className={`badge bg-opacity-10  rounded-circle p-1 ${done ? 'bg-success text-success' : 'bg-warning text-warning'}`}><i className={` font-14 ${done ? 'bi bi-check' : 'bi bi-clock'}`}></i></span>

                                    <span className="text-secondary small flex-grow-1">
                                        {labelText} 
                                        {item.id === 'intro_message' && !done ? (
                                        <span className=""> Arrives with Messages</span>
                                    ) : null}
                                    </span>

                                    <span className={`small  fw-bold ${done ? 'text-success' : 'text-warning'}`}>{done ? 'Done' : 'Pending'}</span>

                                    
                                    
                                </div>
                            );
                        })}
                        
                        
                    
                    </div>
                    </div>
            </div>
            
        </>
    );
};

export default MentorProfileChecklist;
